import React from 'react';
import { EditCategoryRestaurantPropertiesState } from './editCategoryRestaurantPropertiesState/EditCategoryRestaurantPropertiesState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

export const EditCategoryRestaurantPropertiesPage: React.FC = () => {
	return (
		<EditCategoryRestaurantPropertiesState>
			<Forms />
			<ModalWindows />
		</EditCategoryRestaurantPropertiesState>
	);
};
